import Layout from "./components/layout"
import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./routes/MainRoutes";
import ConfirmationModel from "./components/model/ConfirmationModel";
import GetUserProfile from "./components/card/GetUserProfile";

const App = () => {
  return (
    <BrowserRouter>
      <Layout>
        <div className="pt-10">
          <MainRoutes />
        </div>
      </Layout>
      <ConfirmationModel />
      <GetUserProfile />
    </BrowserRouter>
  );
}

export default App;
